import { render, staticRenderFns } from "./WordDict.vue?vue&type=template&id=db5383dc&scoped=true"
import script from "./WordDict.vue?vue&type=script&lang=js"
export * from "./WordDict.vue?vue&type=script&lang=js"
import style0 from "./WordDict.vue?vue&type=style&index=0&id=db5383dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5383dc",
  null
  
)

export default component.exports